export default __webpack_public_path__ + "static/beneficios-emprendedores-c8d0b8de8ce2dd1b82438428f0c8f2bf.png";